import type { VerificationSnapshot } from "./verificationApi";

export function RegistrationFeedback({ registration }: { registration: VerificationSnapshot["registration"] }) {
  if (!registration.rejection) return null;
  return <section className="signup-registration-feedback" aria-label="Carrier feedback">
    <h3>{["submitted", "assistance_requested", "completed"].includes(registration.correction?.status || "") ? "Earlier carrier feedback" : "What needs to change"}</h3>
    <p>{registration.rejection.message}</p>
    {registration.rejection.mode === "assisted" && <p>{registration.correction?.status === "assistance_requested" ? "Our team will help with the next registration step." : registration.rejection.canCorrect ? "Our team needs to help with this registration. You can update your saved details and send them to us for review." : "Contact our support team for help with this registration."}</p>}
  </section>;
}
